import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { getMe } from "src/api/getMe";
import { getAccessToken } from "src/api";
import { NATIVE_EVENT } from "../constants/nativeBridge";
/**
 * 네이티브 앱에서 로그인/로그아웃 완료 시 전달되는 CustomEvent를 수신하여
 * 클라이언트 인증 상태를 갱신하고 관련 쿼리를 무효화하는 훅
 *
 * - LOGIN_RESULT: 쿠키에서 accessToken 읽기 → getMe → auth 갱신 + 쿼리 invalidate
 * - LOGOUT_RESULT: auth 초기화 + 쿼리 invalidate
 *
 * @see docs/native-bridge-notification.md (알림 브릿지 동일 패턴)
 */ const useAuthBridge = ()=>{
    const authStore = useAuthStore();
    const queryClient = useQueryClient();
    useEffect(()=>{
        const handler = async (e)=>{
            const detail = e.detail;
            if (detail.type === NATIVE_EVENT.LOGIN_RESULT && detail.success) {
                try {
                    const accessToken = getAccessToken();
                    if (accessToken) {
                        const { user  } = await getMe(accessToken);
                        authStore.updateUser(user);
                        queryClient.invalidateQueries();
                    }
                } catch (error) {
                    ;
                }
            }
            if (detail.type === NATIVE_EVENT.LOGOUT_RESULT) {
                authStore.logout();
                queryClient.invalidateQueries();
            }
        };
        window.addEventListener("solvookNativeMessage", handler);
        return ()=>window.removeEventListener("solvookNativeMessage", handler);
    }, [
        authStore,
        queryClient
    ]);
};
export default useAuthBridge;
